export default __webpack_public_path__ + "static/Dubrovnik-Croatia-credit-Ivan-Ivankovic-7763173d8cde862472a3b074ba737660.jpg";